import type { FaireProductEntity } from "../../entity_types/product";

export const p_zyp5v9vdxa: FaireProductEntity = {
  token: "p_zyp5v9vdxa",
  type: "product",
  name: "Palo Santo  Stretchable Bracelet 8mm Beads--Sustainably",
  brandToken: "b_4w78fajgal",
  brandName: "Meraki Gemstones",
  imageUrl: "https://cdn.faire.com/fastly/3be27d8196cbddb2ec63559b7f72ec244c15136aebdc489437f00f66ff19ea5a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/04e42910271bbf2a9a84e4fc8580227a3f7c2a3db361f7708a80e859c0e228b2.jpeg",
    "https://cdn.faire.com/fastly/c74821f5fb17a80c7a76d69d44c1dcdf5bf3434cf0f23fd623cde39142d2ed96.jpeg",
    "https://cdn.faire.com/fastly/18e3b90a750a5a553c827ddded727235632457b9fcccaee9a5c760389260e684.png"
  ],
  priceDollars: 9.7,
  description: "Palo Santo stretchable bracelet made with 8mm sized beads.\n*All natural.\n*7.5 inches in length.\n*Sustainably Harvested\n\nOur Palo Santo bracelets are 100% Natural and Sustainably Harvested.  These ultra fragrant Palo Santo bracelets are harvested from trees that have fallen, and are never cut down by force.  The village that farms and collects these trees are accredited by the Peruvian Government.\n\nThis picture is an representation of the type and quality of the gemstone you will be receiving.  As you know, there are slight variations due to the natural character of this product..",
  tags: [],
  msrpDollars: 29.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:15.889Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
